import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import { useParams, useLocation } from "react-router-dom";
import Centered from "../../components/layouts/Centered";
import { useSelector, useDispatch } from "react-redux";
import { loadRecord, reset } from "./clientDetailsSlice";
import EditClientDetails from "./components/EditClientDetails";

const ClientDetails = (props) => {
  const dispatch = useDispatch();
  const [viewMode, setViewMode] = useState(null);
  let location = useLocation();
  const activeClient = useSelector((state) => state.clientDetails.activeClient);
  const fetchLoading = useSelector(
    (state) => state.pendingActions["clientDetails/loadClient"]
  );
  let { id } = useParams();

  useEffect(() => {
    dispatch(loadRecord(id));
    return function cleanup() {
      dispatch(reset());
    };
  }, [dispatch, id]);

  useEffect(() => {
    const isAdmin = location.pathname.includes("admin");
    if (
      isAdmin ||
      (activeClient &&
        activeClient.category &&
        activeClient.category.name === "private")
    ) {
      setViewMode("edit");
    } else if (activeClient && activeClient.category) {
      setViewMode("read");
    }
  }, [activeClient, location.pathname]);

  return fetchLoading ? (
    <Centered style={{ height: "618px" }}>
      <Spin size="large" />
    </Centered>
  ) : viewMode === "edit" ? (
    <EditClientDetails />
  ) : (
    <EditClientDetails readonly={true} />
  );
};

export default ClientDetails;
